var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlGardenViewFilled = function SvgHtlGardenViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.512 13.5v-1.847c-1.075-.754-2.177-.606-3.342-1.771a5.092 5.092 0 0 1-1.1-5.484 8.3 8.3 0 0 1 5.484 1.1 9.472 9.472 0 0 1 3.29 4.387c-1.164 1.164-2.256 1.017-3.335 1.769v1.849a.5.5 0 0 1-.853.351.5.5 0 0 1-.144-.354ZM9.485 5a5.31 5.31 0 0 1 3.52-.646 4.82 4.82 0 0 1-.613 4.475A8.995 8.995 0 0 0 9.485 5Zm-3.5-1.437c.111-.425.352-.804.69-1.086.442-.31.97-.476 1.512-.474a2.624 2.624 0 0 1 1.514.474c.409.276.704.69.831 1.167a6.1 6.1 0 0 0-1.875.762 5.885 5.885 0 0 0-2.67-.844l-.002.001Z"
  })));
};
export default SvgHtlGardenViewFilled;